import React, { useState , useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import GlobalNav from '../../globalComponents/GlobalNav';
import Footer from '../../globalComponents/Footer';
import Loader from '../../utils/loading/Loader';

const AdminConfirmNewPassword = () => {
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [name, setName] = useState('');
  const [isOnboarding, setIsOnboarding] = useState(false);
  const [fmessage, setFmessage] = useState('');
  const [smessage, setSmessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation(); 

  useEffect(() => {
    const { state } = location;
    if (state && state.email) {
      setEmail(state.email);
    } else {
      navigate('/admin-login');
    }
  }, [location, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFmessage('');
    setSmessage('');

    try {
      setIsOnboarding(true);
      const response = await fetch('/pceapi/auth/admin/confirmnewuser', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, current_password: currentPassword, new_password: newPassword, name }),
      });

      const data = await response.json();

      if (data.status === 'success') {
        navigate('/admin-login', { state: { passmessage: data.message } });
      } else {
        setFmessage(data.message || 'An error occurred');
      }
    } catch (error) {
      setFmessage('An error occurred. Please try again.');
    }
    finally{
      setIsOnboarding(false);
    }
  };

  if (isOnboarding)
    return <div><Loader/></div>;
  return (
    <div className="main-window">
      <div className="container">
        <div className="auth-nav-bottom-margin"><GlobalNav/></div>
        <div className="col-xl-5 col-lg-6 col-md-7 col-sm-10 mx-auto">
          <div className="text-center">
            <p className="ev-med-p-dark mb-2">Admin onboarding</p>
            <p className="ev-message-card2 mb-4 rounded p-2">To ensure the security of your account, please create a new password.</p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <input type="hidden" name="remember" defaultValue="true" />
            <label className="ev-reg-p-dark mb-1 mt-3">Email</label>
            <input id="email-address" name="email" type="email" autoComplete="email" className="formField3" placeholder="E.g. john@bms.com" value={email} onChange={(e) => setEmail(e.target.value)} disabled required />
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-3">
                <label className="ev-reg-p-dark mb-1 mt-3">Current password</label>
                <input id="current-password" name="current-password" type="password" required className="formField3" placeholder="Current password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-3">
                <label className="ev-reg-p-dark mb-1 mt-3">Set new password</label>
                <input id="new-password" name="new-password" type="password" required className="formField2" placeholder="New password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
              </div>
            </div>
            <div>
              <label className="ev-reg-p-dark mb-1 mt-3">Name</label>
              <input id="name" name="name" type="text" required className="formField3" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="text-end">
              <br />
              <button type="submit" className="ev-btn-blue-fill-round ev-btn-med ev-bold-reg">Submit details</button>
            </div>
          </form>
          {fmessage && <div className="mt-3 alert alert-danger">{fmessage}</div>}
          {smessage && <div className="mt-3 alert alert-success">{smessage}</div>}
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default AdminConfirmNewPassword;